import { render } from "./InspectionAfter.vue?vue&type=template&id=5317e7a2"
import script from "./InspectionAfter.vue?vue&type=script&lang=js"
export * from "./InspectionAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/InspectionAfter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5317e7a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5317e7a2', __exports__)) {
    api.reload('5317e7a2', __exports__)
  }
  
  module.hot.accept("./InspectionAfter.vue?vue&type=template&id=5317e7a2", () => {
    api.rerender('5317e7a2', render)
  })

}


export default __exports__